import { render, staticRenderFns } from "./EventLayout.vue?vue&type=template&id=719e8c52&"
import script from "./EventLayout.vue?vue&type=script&lang=js&"
export * from "./EventLayout.vue?vue&type=script&lang=js&"
import style0 from "./EventLayout.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
import { VFadeTransition } from 'vuetify/lib/components/transitions';
import { VOverlay } from 'vuetify/lib/components/VOverlay';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VApp,VFadeTransition,VOverlay,VProgressCircular})
